import React from 'react';

import GuidedTooltip, { type GuidedTooltipProps } from 'components/GuidedTooltip';
import createSharedState from 'hooks/createSharedState';

import { makeStyles } from 'tss-react/mui';

export type GuidedPopoverState = {
  anchorEl: Element;
  title: string;
  body: string;
  placement: NonNullable<GuidedTooltipProps['placement']>;
  modifiers: NonNullable<GuidedTooltipProps['modifiers']>;
  onDoNotShowAgain: () => void;
};

const [useGuidedPopoverState, _getGuidedPopoverState, setGuidedPopoverState] =
  createSharedState<GuidedPopoverState | null>(null);

const useStyles = makeStyles()(() => ({
  popper: {
    width: 500,
  },
}));

const FutureTransactionGuidedPopover = () => {
  const { classes } = useStyles();
  const [state, setState] = useGuidedPopoverState();

  if (!state) {
    return null;
  }

  return (
    <GuidedTooltip
      centerArrow
      className={classes.popper}
      onClickAway={() => {
        setState(null);
      }}
      anchorEl={state.anchorEl}
      open={!!state}
      placement={state.placement}
      title={state.title}
      body={state.body}
      continueLabel='OK'
      cancelLabel='DON’T SHOW AGAIN'
      onCancel={() => {
        setState(null);
        state.onDoNotShowAgain();
      }}
      onContinue={() => {
        setState(null);
      }}
      modifiers={state.modifiers}
    />
  );
};

export { setGuidedPopoverState };
export default FutureTransactionGuidedPopover;
